import React from "react";

import { ShowToastProps } from "./types";

export interface iToastContext {
  add: (toast: ShowToastProps) => void;
  remove: (toastId: string) => void;
}
export const ToastContext = React.createContext<iToastContext | null>(null);

/**
 * Lets a nested WhooshToastProvider register its toast handlers with the
 * provider above it. Parents route `add`/`remove` to the deepest registered
 * child so toasts always render on the topmost surface (e.g. inside a modal).
 */
export interface iToastRegistryContext {
  register: (handlers: iToastContext) => () => void;
  /** Adds directly to this provider's toast list, bypassing child routing. */
  addToLocal: (toast: ShowToastProps) => void;
}
export const ToastRegistryContext =
  React.createContext<iToastRegistryContext | null>(null);
